import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    margin-top: var(--console-menu-divider-margin, 15px);\n    margin-bottom: var(--console-menu-divider-margin, 15px);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Nav } from '@alicloud/console-components';
import { getPriority } from '../utils';
/**
 * @public
 */

var Divider = styled(Nav.Divider)(_templateObject(), getPriority(5));
export default Divider;